module.exports = __webpack_public_path__ + "img/Pic_LT_G.52b8dd88.png";